const state = {
  isLoading: 0,
  isUploading: undefined,
  modal: null,
  toast: null,
  unloadAlert: 0,
  afkCountdown: {
    value: 0,
    active: false,
    timer: null
  }
}

const getters = {
  isLoading: state => state.isLoading > 0,
  isUploading: state => state.isUploading,
  modal: state => state.modal,
  toast: state => state.toast,
  unloadAlert: state => state.unloadAlert,
  afkCountdown: state => state.afkCountdown
}

const types = {
  setLoading: 'app/setLoading',
  setUploading: 'app/setUploading',
  addModal: 'app/addModal',
  addToast: 'app/addToast',
  setUnloadAlert: 'app/setUnloadAlert',
  setAFKCountdown: 'app/setAFKCountdown'
}

const mutations = {
  [types.setLoading] (state, boolean) {
    state.isLoading = (boolean === undefined) ? 0 : (boolean ? (state.isLoading + 1) : (state.isLoading - 1))
  },
  [types.setUploading] (state, content) {
    state.isUploading = content
  },
  [types.addModal] (state, object) {
    state.modal = object
  },
  [types.addToast] (state, object) {
    state.toast = object
  },
  [types.setUnloadAlert] (state, boolean) {
    state.unloadAlert = (boolean === undefined) ? 0 : (boolean ? (state.unloadAlert + 1) : (state.unloadAlert - 1))
  },
  [types.setAFKCountdown] (state, object) {
    state.afkCountdown = {
      ...state.afkCountdown,
      ...object
    }
  }
}

const actions = {
  setLoadingAction ({commit}, boolean) {
    commit(types.setLoading, boolean)
  },
  setUploadingAction ({commit}, content) {
    commit(types.setUploading, content)
  },
  addModalAction ({commit}, object) {
    commit(types.addModal, object)
  },
  addToastAction ({commit}, object) {
    commit(types.addToast, object)
  },
  setUnloadAlertAction ({commit}, boolean) {
    commit(types.setUnloadAlert, boolean)
  },
  setAFKCountdownAction ({commit}, object) {
    commit(types.setAFKCountdown, object)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
